export default __webpack_public_path__ + "static/media/home_service_desktop.345763bf.jpg";